// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// NgRx actions
import { setCustomPDFReportBuilderStore } from '../custom-pdf-report-builder/custom-pdf-report-builder.action';
import { setIncludeBenchmarkDefault } from './include-benchmark-default.action';
export const include_benchmark_default = createReducer(false, on(setCustomPDFReportBuilderStore, setIncludeBenchmarkDefault, (state, action) => {
    return action.include_benchmark_default;
}));
